import * as React from 'react';
import { InflationContext } from '../context/InflationContext';

export const useInflationContext = () => {
  return React.useContext(InflationContext);
};
